import { queryOptions, useSuspenseQuery } from "@tanstack/react-query";
import type {
  GetV1LinksByProfileLinkResponse,
  GetV1LinksByProfileLinkSettingsResponse,
} from "../../client";
import {
  getV1LinksByProfileLinkOptions,
  getV1LinksByProfileLinkSettingsOptions,
} from "../../client/@tanstack/react-query.gen";
import { jsonParse } from "../utils/parse";
import type { QueryConfig } from "../utils/query-config";

export const getLinkSettings = (profileLink: string) =>
  queryOptions({
    ...getV1LinksByProfileLinkSettingsOptions({
      path: { profileLink },
    }),
    staleTime: 0,
  });

export const useGetLinkOptions = (
  profileLink: string,
  config?: QueryConfig,
) => {
  return useSuspenseQuery({
    ...getLinkSettings(profileLink),
    ...config,
    select: (data) => jsonParse<GetV1LinksByProfileLinkSettingsResponse>(data),
  });
};
